'use strict';

var React = require('react');

var SvgThemeIcon = function SvgThemeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7.25 3.5a3.75 3.75 0 0 0-3.75 3.75v5.5a3.75 3.75 0 0 0 3.75 3.75h5.5a3.75 3.75 0 0 0 3.75-3.75v-5.5a3.75 3.75 0 0 0-3.75-3.75h-5.5Zm-2.25 3.75a2.25 2.25 0 0 1 2.25-2.25h3.25v3h-5.5v-.75Zm7-2.25h.75a2.25 2.25 0 0 1 2.25 2.25v3.75h-3v-6Zm0 7.5v2.5h.75a2.25 2.25 0 0 0 2.25-2.25v-.25h-3Zm-1.5-3v5.5h-3.25a2.25 2.25 0 0 1-2.25-2.25v-3.25h5.5Z"
  }));
};
SvgThemeIcon.displayName = "ThemeIcon";

exports.SvgThemeIcon = SvgThemeIcon;
